import { SagaIterator } from "redux-saga"
import { put, select, takeEvery } from "redux-saga/effects"
import * as usersFilterActions from "app/redux/usersFilter/usersFilter.actions"
import * as usersTableActions from "app/redux/usersTable/usersTable.actions"
import * as templateTableActions from "app/redux/templateTable/templateTable.actions"
import * as absencesFilterActions from "app/redux/absencesFilter/absencesFilter.actions"
import * as notificationActions from "app/redux/notifications/notifications.actions"
import { resetUrl } from "app/redux/url/url.actions"
import * as selectors from "./moduleContext.selectors"
import * as actions from "./moduleContext.actions"

export function* changeModuleFlow(action: actions.ChangeModuleAction): SagaIterator {
  const { module } = action.payload
  const previousModule = yield select(selectors.getPreviousModule)
  if (previousModule && module !== previousModule) {
    yield put(resetUrl())
    yield put(
      usersFilterActions.actions.changeFilters({
        functions: [],
        status: undefined,
        roles: [],
        q: undefined,
        contract_type: undefined,
      }),
    )
    yield put(
      absencesFilterActions.actions.changeFilters({
        functions: [],
        status: undefined,
        roles: [],
        q: undefined,
        contract_type: undefined,
      }),
    )
    yield put(usersTableActions.actions.changeSorting(["full_name=asc"]))
    yield put(templateTableActions.actions.changeSorting(["name=asc"]))
    yield put(notificationActions.reset())
  }
  yield put(actions.changeModuleSuccess(module))
}

export default function* moduleContextSaga(): SagaIterator {
  yield takeEvery(actions.Types.CHANGE_MODULE, changeModuleFlow)
}
